export const PROFILE_ADDRESSES_LOADING = 'PROFILE_ADDRESSES_LOADING';
export const PROFILE_ADDRESSES_SUCCESS = 'PROFILE_ADDRESSES_SUCCESS';
export const PROFILE_ADDRESSES_ERROR = 'PROFILE_ADDRESSES_ERROR';